export const SHOW_NFT_METADATA = 'SHOW_NFT_METADATA' as const;

export default {
  SHOW_NFT_METADATA,
};
